<template>
  <div>
    <h1>{{ dealer.name }}</h1>

    <div v-if="dealerToken">
      <p>Para imprimir <strong>via Web</strong>, acesse o link:</p>
      <b-form-input type="text" :value="link(dealerToken)"></b-form-input>
      <br>
      <p>Para imprimir <strong>via Aplicativo</strong>, leia o QRCode:</p>
      <canvas class="qrcode" ref="canvas"></canvas>

      <p>Ou copie o código de ativação usando o botão abaixo e cole no Aplicativo:</p>
      <b-input-group class="mt-2">
        <b-input-group-prepend>
          <b-button
            v-b-tooltip.hover
            @click="copyQRCodeContent">
            <icon name="copy" class="mx-0"></icon> Copiar código de ativação
          </b-button>
        </b-input-group-prepend>
        <b-form-input size="md"  v-model="dealerToken" disabled></b-form-input>
      </b-input-group>
    </div>

    <b-table bordered striped hover show-empty
      class="my-4"
      primary-key="id"
      empty-text="Nenhum lote encontrado"
      responsive
      :items="dealer.batches"
      :fields="this.$gui.isEvento ? fieldsEvento : fieldsFicha"
    >

      <template v-slot:cell(value_fmted)="data">
        <span v-if="data.item.value > 0">{{ data.item.value | currency }}</span>
        <span v-else class="text-info">Grátis</span>
      </template>

      <template v-slot:cell(actions)="data">
        <div>
          <toggle-button
            :value="data.item.is_available === 1"
            :sync="true" :width="45" :height="25"
            :color="{checked: '#26A65B', unchecked: '#E74C3C'}"
            @change="switchBatch(data.item)"
          />
        </div>
      </template>
    </b-table>

  </div>
</template>

<script>
import QRCode from 'qrcode'
import ToggleButton from 'vue-js-toggle-button/src/Button'
import copy from 'copy-to-clipboard'

export default {
  name: 'OrganizerDealer',
  components: {
    ToggleButton
  },
  data () {
    return {
      toggle: null,
      organizer: this.$route.params.organizer,
      dealerId: this.$route.params.id,
      dealer: '',
      dealerToken: '',
      fieldsEvento: [
        {key: 'name', label: this.$gui.batch, class: ['align-middle'] },
        {key: 'value_fmted', label: 'Preço', formatter: this.$options.filters.currency, class: ['text-nowrap', 'align-middle', 'text-center']},
        {key: 'actions', label: 'Visível?', class: ['text-nowrap', 'text-center', 'align-middle'] }
      ],
      fieldsFicha: [
        {key: 'name', label: this.$gui.batch, class: ['align-middle'] },
        {key: 'value_fmted', label: 'Preço', formatter: this.$options.filters.currency, class: ['text-nowrap', 'align-middle', 'text-center']},
        {key: 'actions', label: 'Visível?', class: ['text-nowrap', 'text-center', 'align-middle'] }
      ],
    }
  },
  mounted () {
    this.getDealer(this.dealerId)
  },
  updated () {
    this.handleQrcode(this.dealerToken)
  },
  methods: {
    handleQrcode (token) {
      if (!token) return
      let canvas = this.$refs.canvas
      let opt = { errorCorrectionLevel: 'H' }
      QRCode.toCanvas(canvas, token, opt, function (error) {
        if (error) console.error(error)
      })
    },
    link (token) {
      if (token === undefined || token === null) {
        return null
      }
      let route = this.$router.resolve({
        name: 'DealerOverview',
        params: {
          dealer: token
        }
      })
      return process.env.VUE_APP_URL_APP + route.href
    },
    getDealer (dealerId) {
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/dealers/' + dealerId
      return this.$http.get(url).then(
        res => {
          this.dealer = res.body
          this.dealerToken = res.body.token
        },
        err => {
          alert(err.body.message)
          console.log(err)
        }
      )
    },
    async switchBatch (batch) {
      let endpoint = process.env.VUE_APP_URL_APP + `/b/organizers/${this.organizer}/dealers/${this.dealer.id}`
      let batchesIds = this.$_.map(this.availableBatches, b => b.id)
      let data = { batches: batchesIds }

      if (batch.is_available === 0) {
        data.batches.push(batch.id)
      } else if (batch.is_available === 1) {
        this.$_.pull(data.batches, batch.id)
      }

      try {
        let resp = await this.$http.put(endpoint, data)
        this.dealer.batches = resp.body.batches
      } catch (err) {
        console.log(err)
      }
    },
    copyQRCodeContent () {
      copy(this.dealerToken)

      this.$bvToast.toast(`Código de ativação copiado com sucesso`, {
        autoHideDelay: 3000,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: 'success'
      })
    },
  },
  computed: {
    availableBatches () {
      return this.$_.filter(this.dealer.batches, b => b.is_available)
    }
  }
}
</script>
<style>
.qrcode {
    padding-left: 0;
    padding-right: 0;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 20px;
    display: block;
}
</style>
